import { render, staticRenderFns } from "./SelfAssessment.vue?vue&type=template&id=271aa48f&scoped=true"
import script from "./SelfAssessment.vue?vue&type=script&lang=js"
export * from "./SelfAssessment.vue?vue&type=script&lang=js"
import style0 from "./SelfAssessment.vue?vue&type=style&index=0&id=271aa48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271aa48f",
  null
  
)

export default component.exports